import React from 'react'
import { ApolloClient } from '@apollo/client'
import { PayPalButtonsComponentProps, PayPalScriptProvider } from '@paypal/react-paypal-js'
import { Maybe } from '@/utils/types'
import { PayPalButton } from './PayPalButton'

interface PayPalPaymentProps {
  name: Maybe<string>
  description: string
  // ^ Max 127 characters
  // For accounting should follow one of these formats:
  //Angel Studios: sound-of-freedom:pif
  //Angel Studios: the-chosen:pif
  softDescriptor: string
  // ^ Max 22 characters
  currency: string
  // ^ Max 3 characters - uppercase
  amount: string
  buttonHeight: number
  sku: string
  isGuest?: boolean
  onComplete: ({ orderId, paymentMethod }: { orderId: string; paymentMethod: string }) => void
  disabled?: boolean
  bimClient?: ApolloClient
  venmoStyleOverride?: PayPalButtonsComponentProps['style']
  paypalStyleOverride?: PayPalButtonsComponentProps['style']
}

export const PayPalPayment: React.FC<PayPalPaymentProps> = ({
  name,
  description,
  softDescriptor,
  currency,
  amount,
  buttonHeight,
  sku,
  onComplete,
  isGuest = false,
  disabled = false,
  bimClient,
  venmoStyleOverride,
  paypalStyleOverride,
}) => {
  const payPalOptions = {
    'client-id': process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID || '',
    currency,
    intent: 'capture',
    'enable-funding': 'venmo',
    components: 'buttons',
  }

  return (
    <>
      <PayPalScriptProvider options={payPalOptions}>
        <PayPalButton
          isGuest={isGuest}
          name={name}
          description={description}
          softDescriptor={softDescriptor.substring(0, 22)}
          sku={sku}
          venmo={false}
          onComplete={onComplete}
          currency={currency}
          amount={amount}
          buttonHeight={buttonHeight}
          disabled={disabled}
          bimClient={bimClient}
          venmoStyleOverride={venmoStyleOverride}
          paypalStyleOverride={paypalStyleOverride}
        />
        <PayPalButton
          isGuest={isGuest}
          name={name}
          description={description}
          softDescriptor={softDescriptor.substring(0, 22)}
          sku={sku}
          venmo
          onComplete={onComplete}
          currency={currency}
          amount={amount}
          buttonHeight={buttonHeight}
          disabled={disabled}
          bimClient={bimClient}
          venmoStyleOverride={venmoStyleOverride}
          paypalStyleOverride={paypalStyleOverride}
        />
      </PayPalScriptProvider>
    </>
  )
}
